export default __webpack_public_path__ + "c31049f2e87324c79eeee84327a8a59a.svg";